import { RootState } from '../../RootState';
import selectRequiredSettings from './selectRequiredSettings';

const selectPublicBaseUrl = (state: RootState): string => {
  const settings = selectRequiredSettings(state);
  return settings.publicBaseUrl;
};

export default selectPublicBaseUrl;
